import { Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";
import { ProgressState } from "@/shared/interfaces/WizardState.interface";

const state: ProgressState = {
    main: 0,
    mainMax: 1,
    sub: 0,
    subMax: 1,
    hasSub: true,
};

const mutations: MutationTree<ProgressState> = {
    main: function(state, value: number) {
        state.main = value;
    },

    mainMax: function(state, value: number) {
        state.mainMax = value;
    },

    sub: function(state, value: number) {
        state.sub = value;
    },

    subMax: function(state, value: number) {
        state.subMax = value;
    },

    hasSub: function(state, value: boolean) {
        state.hasSub = value;
    },
};

const form: Module<ProgressState, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
};

export default form;
